import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Media from 'react-media'
import Animate from 'rc-animate'
import ReactLoading from 'react-loading'
import Cookies from 'js-cookie'

import { Avatar, Typography, Row, Col, Drawer } from 'antd'
import { SmileFilled } from '@ant-design/icons'

import useWindowSize from '_src/hooks/useWindowSize'
import useWallet from '_src/hooks/useWallet'

import { getNetworkName } from '_src/utils/chain/chainConfFunc'
import { showShortAddress, isMainNetwork } from '_src/utils/chain'

import { useAppSelector, useAppDispatch } from '_src/store/hooks'
import { getBalanceList } from '_src/store/global/actions'
import Button from '_src/components/Button'
import { setPayments } from '_src/store/globalPayments/reducer'

import { getCollectList } from '_src/servers/v3/collect'

import { verifySignStatus } from '_src/contracts/sign'

import { Wrap } from '_src/pages/global/convert'
import { isMainCurrency } from '_src/contracts/common'

import Icon from '../Icon'
import './index.less'

const { Paragraph } = Typography

const User = ({ type }) => {
  const { walletConnect, walletDisconnect } = useWallet()

  const { theme, loginLoading, balanceListLoading, connected, userData, balanceList, address, networkId } =
    useAppSelector((store) => store.global)
  const dispatch = useAppDispatch()
  const history = useHistory()
  const size = useWindowSize()
  const { t } = useTranslation()

  const [show, setShow] = useState(false)

  const handleWrapClick = () => {
    setShow(false)
  }

  const showWrap = (networkId, item) => {
    if (isMainNetwork(networkId)) {
      const { contract_addr, symbol = '' } = item
      if (isMainCurrency(contract_addr) || symbol == 'WAAC') return true
    }

    return false
  }

  const handleShow = (flag) => {
    if (flag) {
      connected && dispatch(getBalanceList())
    }

    setShow(flag)
  }
  const handleMenuLink = async ({ pathname, state }) => {
    if (pathname == '/settings') {
      const res = await verifySignStatus().catch((error) => {
        // 拒绝签名
        console.log(error)
        return
      })
      if (!res) return
      history.push({
        pathname,
        state,
      })
    } else if (pathname == '/account') {
      history.push({
        pathname: `${pathname}/${userData.nick_name}`,
      })
    } else {
      history.push({
        pathname,
        state,
      })
    }

    handleShow(false)
  }
  //先判断我的合集 ？ 跳转到 My Collection ：/createCollection
  const handleMeunCollection = async () => {
    let data = {
      chain_id: networkId,
      address,
    }
    const result = await getCollectList(data)
    if (result && result.code == 1000) {
      const { data: { total = '' } = {} } = result
      if (total > 0) {
        history.push({ pathname: '/myCollections', state: {} })
      } else {
        setShow(false)
        history.push({ pathname: '/createCollection', state: {} })
      }
    } else {
      setShow(false)
      history.push({ pathname: '/createCollection', state: {} })
    }
  }
  const connect = async () => {
    const res = await walletConnect().catch((error) => {
      console.log('钱包连接失败', error)
    })
    console.log('是否连接成功', res)
  }

  const quit = async () => {
    Cookies.remove('access_token')
    await walletDisconnect().catch((error) => {
      console.log('钱包退出失败', error)
    })
    size < 750 && handleShow(false)
  }

  const showUserModal = () => {
    if (Object.keys(userData).length > 0 && show) {
      return true
    } else {
      return false
    }
  }

  const avatar = (
    <Avatar
      key={userData?.avatar_url || 1}
      onClick={() => {
        size < 1199 && handleShow(true)
      }}
      // onMouseEnter={(e) => {
      //   e.stopPropagation();
      //   e.nativeEvent.stopImmediatePropagation();
      //   size > 750 && handleUpdata();
      // }}
      size={size < 1199 ? 32 : 40}
      src={userData?.avatar_url}
      className="user-avatar"
    />
  )

  const UserConnect = (
    <>
      <div className="user-modal-header">
        <div className="modal-left-container">
          <Avatar key={userData?.avatar_url || 2} size={size < 1199 ? 54 : 48} src={userData?.avatar_url} />
          <div className="header-content">
            {userData?.nick_name && <div className="header-username">{userData.nick_name}</div>}
            <div className="header-account">
              <Paragraph
                copyable={{
                  text: address,
                  icon: [
                    <Icon key="copy-icon" type="icon-copyable-decolorization" />,
                    <SmileFilled key="copied-icon" />,
                  ],
                  tooltips: false,
                }}
              >
                <div className="account-text">{showShortAddress(address)}</div>
              </Paragraph>
            </div>
          </div>
        </div>

        <Media
          query="(max-width: 750px)"
          render={() => (
            <div
              className="right-icon-container"
              onClick={() => {
                handleShow(false)
              }}
            >
              <Icon type="icon-closed" className="right-icon" />
            </div>
          )}
        />
      </div>

      <div className="user-modal-content">
        <Row gutter={[0, 32]} align="middle" justify="start">
          <Col
            xl={{ span: 14 }}
            xs={{ span: 14 }}
            className="content-item"
            onClick={() => {
              handleMenuLink({ pathname: '/account', state: {} })
            }}
          >
            <Icon type="icon-my-nfts" className="content-icon" />
            <div className="content-text">{t('user.my_nfts')}</div>
          </Col>
          <Col
            onClick={() => {
              handleMenuLink({ pathname: '/settings', state: {} })
            }}
            xl={{ span: 10 }}
            xs={{ span: 10 }}
            className="content-item"
          >
            <Icon type="icon-settings" className="content-icon" />
            <div className="content-text">{t('user.settings')}</div>
          </Col>
          {isMainNetwork(networkId) && (
            <Col xl={{ span: 14 }} xs={{ span: 14 }} className="content-item" onClick={handleMeunCollection}>
              <Icon type="icon-my-collections" className="content-icon" />
              <div className="content-text">{t('user.my_collections')}</div>
            </Col>
          )}

          <Col xl={{ span: 10 }} xs={{ span: 10 }} className="content-item">
            <Icon type="icon-log-out" className="content-icon" />
            <div onClick={quit} className="content-text">
              {t('user.log_out')}
            </div>
          </Col>
        </Row>
      </div>

      {balanceListLoading ? (
        <ReactLoading
          className="user-modal-balance-loading"
          type="spokes"
          color={theme === 'dark' ? '#fff' : '#333'}
          height={16}
          width={16}
        />
      ) : (
        <>
          {balanceList?.currencies && balanceList.currencies.length > 0 && (
            <div className="user-modal-footer">
              {balanceList.currencies.map((item, index) => (
                <div key={index} className="footer-item">
                  {item?.symbolUrl && (
                    <div className="balance-chain-icon">
                      <img src={item.symbolUrl} alt="" />
                    </div>
                  )}
                  <div className="assets-content">
                    <div className="content-top">
                      <div>{item.symbol}</div>{' '}
                      <div className="content-top-balance">
                        <div>{item.balance}</div>
                        {showWrap(balanceList?.chain_id, item) && (
                          <Wrap
                            t={t}
                            className="balance-wrap"
                            data={item}
                            list={balanceList}
                            handleWrapClick={handleWrapClick}
                          />
                        )}
                      </div>
                    </div>
                    <div className="content-bottom">
                      {balanceList?.chain_id && <div>{getNetworkName(balanceList?.chain_id)}</div>}
                      <div>${item.equivalent_usdt} USD</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {!isMainNetwork(networkId) && (
        <Button className="add_funds" onClick={() => dispatch(setPayments(true))}>
          {t('globalPayments.add_funds')}
        </Button>
      )}
    </>
  )

  return (
    <div
      className="user-container"
      onMouseEnter={() => {
        size > 1199 && handleShow(true)
      }}
      onMouseLeave={() => {
        size > 1199 && handleShow(false)
      }}
    >
      <>
        {type === 'mobile' ? (
          <>
            {Object.keys(userData).length > 0 && avatar}
            <Drawer
              onClose={() => {
                handleShow(false)
              }}
              placement="right"
              closable={false}
              visible={show}
              className="user-drawer"
            >
              {UserConnect}
            </Drawer>
          </>
        ) : (
          <>
            {Object.keys(userData).length > 0 ? (
              avatar
            ) : (
              <div onClick={connect} className="connect-wallet-button">
                {loginLoading && (
                  <ReactLoading
                    className="wallet-button-loading"
                    type="spokes"
                    color={theme === 'dark' ? '#fff' : '#333'}
                    height={16}
                    width={16}
                  />
                )}

                <div className="wallet-button-text">{t('common.connect_wallet')}</div>
              </div>
            )}

            <Animate transitionName="inft-fade" transitionAppear>
              {showUserModal() && (
                <div className="user-modal" key="user-modal">
                  {UserConnect}
                </div>
              )}
            </Animate>
          </>
        )}
      </>
    </div>
  )
}

export default User
